export const NLP_API_URL = import.meta.env.VITE_NLP_API_URL || `${import.meta.env.VITE_API_ORIGIN}/nlp`;
